import { useState } from 'react';

import { Styled } from './controlled-radio-button-group.styles';

interface ControlledRadioButtonGroupProps {
  name: string;
  values: { value: string; label: string }[];
  orientation?: 'vertical' | 'horizontal';
  onChange?: (name: string, value: string) => void;
}

const ControlledRadioButtonGroup = ({
  name,
  orientation,
  values,
  onChange,
}: ControlledRadioButtonGroupProps): JSX.Element => {
  const [selectedValue, setSelectedValue] = useState<string>();

  const handleChange = (value: string): void => {
    setSelectedValue(value);
    onChange?.(name, value);
  };

  return (
    <Styled.StyledRadioButtonGroup orientation={orientation}>
      {values.map(({ value, label }, index) => (
        <Styled.StyledLabel key={`${name}-radio-button-${index}`}>
          <Styled.HiddenRadioButton
            name={name}
            on={selectedValue === value}
            onChange={() => handleChange(value)}
            value={value}
          />
          <Styled.StyledCircle $checked={selectedValue === value}>
            {label}
          </Styled.StyledCircle>
        </Styled.StyledLabel>
      ))}
    </Styled.StyledRadioButtonGroup>
  );
};

export default ControlledRadioButtonGroup;
